import React from 'react';
import { BaseProps } from 'src/modules/shared/types/component.type';
import Switch from 'src/modules/shared/components/atoms/switch';
import Label from 'src/modules/shared/components/atoms/inputs/label';
import { Text } from 'src/modules/shared/components/atoms/text';

interface LabelSwitchProps extends BaseProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  helperText?: string;
  labelPosition?: 'left' | 'right' | 'top';
}

/**
 * A switch input with a label
 */
const LabelSwitch: React.FC<LabelSwitchProps> = ({
  label,
  checked,
  onChange,
  id = `switch-${Math.random().toString(36).substring(2, 9)}`,
  required = false,
  disabled = false,
  error,
  variant = 'primary',
  size = 'sm',
  className = '',
  helperText,
  labelPosition = 'left',
}) => {
  const isTopLabel = labelPosition === 'top';

  return (
    <div
      className={`flex ${isTopLabel ? 'flex-col' : 'items-center'} ${className}`}
    >
      {(labelPosition === 'left' || labelPosition === 'top') && (
        <div className={`${isTopLabel ? 'mb-1' : 'mr-3'}`}>
          <Label title={label} required={required}>
            {label}
          </Label>
        </div>
      )}
      <div className="flex items-center">
        <Switch
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          variant={variant}
          size={size}
          label={labelPosition === 'right' ? label : undefined}
          labelPosition="right"
          className={`id-${id}`}
        />
      </div>
      {error && (
        <Text size="small" color="danger" className="mt-1">
          {error}
        </Text>
      )}
      {helperText && !error && (
        <Text size="tiny" color="secondary" className="mt-1">
          {helperText}
        </Text>
      )}
    </div>
  );
};

export default LabelSwitch;
